export default __webpack_public_path__ + "static/media/IMG-20240708-WA0027.e6bbf3ff.jpg";